import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import { getIdByUrl } from 'utils/tools';

const BatchBreadCrumb = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const currentData = useSelector<DynamicObjectType>(
    (state) => state.transferOrdersBatch.currentData,
  );

  const _id = useMemo(
    () => getIdByUrl({ model: 'transfer-orders' }, location) || params.id,
    [params.id],
  );

  useEffect(() => {
    dispatch(
      crudActions.transferOrdersBatch.getDataById({
        data: { id: _id },
        options: {
          isRequestApi: true,
        },
      }),
    );
  }, [_id]);

  return (
    <div>
      <FontAwesomeIcon
        icon={faChevronLeft}
        className="cursor-pointer"
        onClick={() => window.history.back()}
      />
      <span className="font-bold text-sm ml-2.5">{`Batch ID ${currentData?.id}`}</span>
    </div>
  );
};

export default BatchBreadCrumb;
